import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

type GrupoUsuario = {
    idGrupoUsuario: number;
    dsGrupoUsuario: string;
};

export function GrupoUsuarioAutoComplete({
    sx,
    name,
    value,
    error,
    options,
    readOnly,
    disableClearable,
    multiple = false,
    disabled = false,
    onChange = () => {},
    size = 'medium',
    label = 'Grupo de usuários',
    requestOptions = {
        url: '/gestao/grupousuario',
        sort: [{ property: 'idGrupoUsuario', direction: 'ASC' }],
        columns: 'idGrupoUsuario,dsGrupoUsuario',
        limit: 50,
    },
}: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            sx={sx}
            name={name}
            size={size}
            label={label}
            value={value}
            error={error}
            options={options}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            readOnly={readOnly}
            disableClearable={disableClearable}
            requestOptions={requestOptions}
            objectId="idGrupoUsuario"
            selectedStringTemplate="{dsGrupoUsuario}"
            optionStringTemplate="{dsGrupoUsuario}"
            isOptionEqualToValue={(option: GrupoUsuario, value: GrupoUsuario) => value && option && option.idGrupoUsuario === value.idGrupoUsuario}
        />
    );
}
